import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SORT_NAME, SORT_LAST_ACTIVITY } from '../customer-selection-view/customer-sort-constants';
import {
  ADMIN_ROLE,
  CAREAPP_MANAGER,
  COORDINATOR_ROLE,
  DASHBOARD_ROLES,
  ORGANISATION_ADMIN_ROLE,
  STAFF_ROLES,
} from '@careapp-group/core';

@Component({
    selector: 'ca-customer-filter',
    templateUrl: './customer-filter.component.html',
    styleUrls: ['./customer-filter.component.scss'],
    standalone: false
})
export class CustomerFilterComponent {
  public CAN_VIEW_DISABLED = [
    ORGANISATION_ADMIN_ROLE,
    COORDINATOR_ROLE,
    ADMIN_ROLE,
    CAREAPP_MANAGER,
  ];
  public SORT_NAME = SORT_NAME;
  public SORT_LAST_ACTIVITY = SORT_LAST_ACTIVITY;
  public STAFF_AND_DASHBOARD_ROLES = [...DASHBOARD_ROLES, ...STAFF_ROLES];

  @Input() showEnabledToggle: boolean = false;
  @Input() sortMethod: string = SORT_NAME;
  @Input() enabledOnly: boolean = true;
  @Output() onEnabledOnlyChange: EventEmitter<boolean> = new EventEmitter();
  @Output() onSortMethodChange: EventEmitter<string> = new EventEmitter();

  constructor() {}
}
